<template>
  <div class="pr-1">
    <br />
    <div id="bar-chart-h"></div>
    <br />
    <v-divider  style="margin: 0px 20px 0px 20px !important" />
    <br />
    <vue-good-table
      :columns="Columns"
      :rows="rows"
      style-class="vgt-table condensed bordered striped"
      row-style-class="tablerowheight"
      :sort-options="{
         enabled: true,
         initialSortBy: {field: 'clipDuration', type: 'desc'}
      }"
       style="padding: 0px 20px 0px 20px !important"
      class="chart-table-airtime"
    >
      <template slot="table-column" slot-scope="props">
        <span class="tablerowheight">{{props.column.label}}</span>
      </template>

      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'sponsor'">
          <span style="text-align: center">{{props.row.sponsor}}</span>
        </span>
        <span v-if="props.column.field == 'clipDuration'">
          <span style="text-align: center">{{changeTimeFormat(props.row.clipDuration)}}</span>
        </span>
      </template>
    </vue-good-table>
  </div>
</template>


<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_material from "@amcharts/amcharts4/themes/material";
import { mapState } from "vuex";
import adminSchema from "@/schemas/admin.json";
import colorValues from "values.js";

//am4core.useTheme(am4themes_animated);
am4core.useTheme(am4themes_material);


export default {
  name: "SponsorsByAirTime",
  props: {
    admin: {
      type: Object,
      default() {
        return {};
      }
    },
    schema: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      rows: [],
      filteredRows: [],
      chartData: []
    };
  },
  computed: {
    ...mapState({
      portal: state => state.portal,
      clip: state => state.clip,
      gameID: state => state.game.gameID,
      sponByGameResult: state => state.clip.sponByGameResult
    }),
    Columns() {
      return adminSchema.clipsBarChartHorizontal.columns;
    }
  },
  watch: {
    sponByGameResult: {
      handler: function() {
        this.rows = this.sponByGameResult;
        this.rows = [];
        this.filteredRows = [];
        this.computeAirtimeBySponsor();
      },
      deep: true
    },
    Columns: {
      handler: function() {
        this.tableCol = this.Columns;
      }
    }
  },
  methods: {
    changeTimeFormat(time) {
      var s = Math.floor(time % 60);
      var m = Math.floor((time / 60) % 60);
      var h = Math.floor(time / 3600);
      if (isNaN(time) || time === Infinity) {
        h = m = s = "--";
      }
      h = h > 0 ? h + ":" : "";
      m = (h && m < 10 ? "0" + m : m) + ":";
      s = s < 10 ? "0" + s : s;
      return (time = h + m + s);
    },
    computeAirtimeBySponsor() {
      var v = this;

      // this.sponByGameResult.forEach(function(a) {
      //   if (!this[a.sponsor]) {
      //     this[a.sponsor] = { sponsor: a.sponsor, clipDuration: 0 };
      //     v.filteredRows.push(this[a.sponsor]);
      //   }
      //   this[a.sponsor].clipDuration += a.clipDuration;
      // }, Object.create(null));

      // this.filteredRows = this.$sortBy(this.filteredRows, 'clipDuration').reverse();
      // //this.filteredRows = this.filteredRows
      // this.rows = this.filteredRows.slice(0, 5);
      // this.rows = this.rows.reverse();

      // var filteredRows = this.$filter(this.sponByGameResult, {type: "Motion"})
      var filteredRows = this.sponByGameResult;
      
      filteredRows = this.$_(filteredRows)
        .groupBy('sponsor')
        .map((objs, key) => {
          return {
            'sponsor': key,
            'clipDuration': this.$_.sumBy(objs, 'clipDuration'),
          }
        })
        .value()

      filteredRows = this.$sortBy(filteredRows, 'clipDuration')
      filteredRows = filteredRows.reverse();
      filteredRows = filteredRows.slice(0,5);
      this.rows = filteredRows.reverse();

    },
    createChart() {
      am4core.useTheme(am4themes_animated);
      // Create chart instance
      var chart = am4core.create("bar-chart-h", am4charts.XYChart);
      // Add data
      chart.data = this.rows;
      var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "sponsor";
      //categoryAxis.title.text = "Sponsors";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.inside = true;
      categoryAxis.fontSize = 13;
      categoryAxis.renderer.labels.template.fill = "#ffffff";      
      var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
      valueAxis.dataFields.value = "clipDuration";
      valueAxis.title.text = "Total AirTime (secs)";
      var series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueX = "clipDuration";
      series.dataFields.categoryY = "sponsor";
      var valueLabel = series.bullets.push(new am4charts.LabelBullet());
      //valueLabel.label.text = "{value}";
      valueLabel.label.fontSize = 8;
      series.name = "Value";
      series.tooltipText = "{name}: [bold]{clipDuration}[/]";
      series.stacked = true;
      series.columns.template.adapter.add("fill", function(fill, target) {
        return chart.colors.getIndex(target.dataItem.index);
      });
      series.strokeWidth = 0;
      chart.tapToActivate = true;
      chart.cursor = new am4charts.XYCursor();
    },
    orientationChange() {
      this.createChart();
      //console.log("Orientation changed");
    },
    resize() {
      this.createChart();
      //console.log("Page resized");
    }
  },

  created() {
    var v = this;
    window.addEventListener("orientationchange", v.orientationChange, false);
    window.addEventListener("resize", v.resize, false);
    this.rows = [];
    this.computeAirtimeBySponsor();

  },
  beforeUpdate() {
    this.createChart();
  },
  mounted() {
    this.createChart();
  },
  beforeDestroy() {
    window.removeEventListener("orientationchange", this.orientationChange);
    window.removeEventListener("resize", this.resize);
  }
};
</script>


<style>
#bar-chart-h {
  width: 100%;
  height: 450px;
}

.chart-table-airtime .vgt-table.condensed td, .vgt-table.condensed th.vgt-row-header{
  padding: 0.4em 2.1em .4em 0.4em !important;
  font-size: 14px !important;
}

.chart-table-airtime .vgt-table th{
  padding: 0.4em 0.2em .4em 0.2em !important;
}

.chart-table-airtime .tablerowheight{
  font-size: 16px !important;
}
</style>

